var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTick = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.225 16.374c.35 0 .628-.142.823-.418L17.757 4.86c.146-.216.212-.38.212-.552 0-.41-.302-.678-.75-.678-.319 0-.506.097-.702.38L9.192 14.68 5.39 10.13c-.204-.26-.4-.365-.702-.365-.456 0-.783.291-.783.701 0 .172.082.366.237.545l4.233 4.93c.253.29.498.432.849.432z",
    transform: "translate(-3.5 -2.5)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tick.a53d41cfe14f699232ff6822a308d2ef.svg";